const CommunityDescription = {
    title: 'COMMUNITIES_INFORMATION',
    key: [],
    sections: [
        {
            columns: 6,
            fields: [
                {
                    label: 'COMMUNITIES_NAME',
                    isRequired: true,
                    key: ['name'],
                    pos: {
                        col: 1,
                        row: 1,
                        size: 2,
                    },
                },
                {
                    label: 'COMMUNITIES_TRANSLATED_NAME_EN',
                    key: ['translatedName', 'en'],
                    pos: {
                        col: 1,
                        row: 2,
                        size: 1,
                    },
                },
                {
                    label: 'COMMUNITIES_TRANSLATED_NAME_CN',
                    key: ['translatedName', 'cn'],
                    pos: {
                        col: 2,
                        row: 2,
                        size: 1,
                    },
                },
                {
                    label: 'COMMUNITIES_IS_CELLAR',
                    type: 'checkbox',
                    key: ['isCellar'],
                    pos: {
                        col: 1,
                        row: 3,
                        size: 1,
                    },
                },
                {
                    label: 'COMMUNITIES_IS_PET',
                    type: 'checkbox',
                    key: ['isPet'],
                    pos: {
                        col: 2,
                        row: 3,
                        size: 1,
                    },
                },
                {
                    label: 'COMMUNITIES_STATUS',
                    type: 'select',
                    isRequired: true,
                    key: ['status'],
                    options: [
                        {
                            label: 'COMMUNITIES_STATUS_PUBLISH',
                            key: 'publish',
                        },
                        {
                            label: 'COMMUNITIES_STATUS_NOT_PUBLISH',
                            key: 'not_publish',
                        },
                    ],
                    pos: {
                        col: 1,
                        row: 4,
                        size: 1,
                    },
                },
            ],
        },
    ],
}

const DEFAULT_ICON_STYLE =
    'linear-gradient(105deg, #98F183 0%, #11BF67 100%)'
const DEFAULT_ICON_HEAD_STYLE =
    'linear-gradient(105deg, #98F183 0%, #11BF67 100%)'
const DEFAULT_ICON_HFIVE_STYLE =
    'linear-gradient(105deg, #98F183 0%, #11BF67 100%)'
const DEFAULT_TEXT_GRADIENT =
    'linear-gradient(105deg, #98F183 0%, #11BF67 100%)'
const DEFAULT_BG_HFIVE =
    'linear-gradient(105deg, #98F183 0%, #11BF67 100%)'
const DEFAULT_ICON_HEAD_BORDER_PERCENT = 2

const normalizeUpload = (value) => {
    if (!value) {
        return value
    }

    const file = value?.fileList ? value.fileList[0] : value
    if (!file) {
        return null
    }

    return file?.response ? file.response : file
}

const cleanBeforeSending = (values) => {
    const nextValues = { ...values }

    nextValues.iconSource = normalizeUpload(nextValues.iconSource)
    nextValues.iconHeadSource = normalizeUpload(nextValues.iconHeadSource)
    nextValues.iconHFiveSource = normalizeUpload(nextValues.iconHFiveSource)
    nextValues.logoPDF = normalizeUpload(nextValues.logoPDF)
    nextValues.iconQRCode = normalizeUpload(nextValues.iconQRCode)

    // Backend owns baking; keep existing baked files if present on edit.
    if (nextValues.icon && nextValues.icon.fileList) {
        nextValues.icon = normalizeUpload(nextValues.icon)
    }
    if (nextValues.iconHead && nextValues.iconHead.fileList) {
        nextValues.iconHead = normalizeUpload(nextValues.iconHead)
    }
    if (nextValues.iconHFive && nextValues.iconHFive.fileList) {
        nextValues.iconHFive = normalizeUpload(nextValues.iconHFive)
    }

    const mpConfig = { ...(nextValues.mpConfig || {}) }

    // Always persist gradients independently (never omit iconHeadStyle / iconHFiveStyle).
    mpConfig.iconStyle = mpConfig.iconStyle || DEFAULT_ICON_STYLE
    mpConfig.iconHeadStyle = mpConfig.iconHeadStyle || DEFAULT_ICON_HEAD_STYLE
    mpConfig.iconHFiveStyle = mpConfig.iconHFiveStyle || DEFAULT_ICON_HFIVE_STYLE
    mpConfig.textGradient = mpConfig.textGradient || DEFAULT_TEXT_GRADIENT
    if (
        mpConfig.iconHeadBorderPercent == null ||
        mpConfig.iconHeadBorderPercent === ''
    ) {
        mpConfig.iconHeadBorderPercent = DEFAULT_ICON_HEAD_BORDER_PERCENT
    }

    nextValues.mpConfig = mpConfig
    nextValues.bgHFive = nextValues.bgHFive || DEFAULT_BG_HFIVE
    nextValues.isCellar = !!nextValues.isCellar
    nextValues.isPet = !!nextValues.isPet

    delete nextValues.iconSize
    delete nextValues.iconHeadSize

    return nextValues
}

const formatCommunityData = (data) => ({
    ...data,
    isCellar: !!data?.isCellar,
    isPet: !!data?.isPet,
    bgHFive: data?.bgHFive || DEFAULT_BG_HFIVE,
    zikoContact: {
        en: '',
        cn: '',
        ...(data?.zikoContact || {}),
    },
    zikoContactId: data?.zikoContactId || '',
    status: data?.status || 'publish',
    mpConfig: {
        iconStyle: DEFAULT_ICON_STYLE,
        iconHeadStyle: DEFAULT_ICON_HEAD_STYLE,
        iconHFiveStyle: DEFAULT_ICON_HFIVE_STYLE,
        textGradient: DEFAULT_TEXT_GRADIENT,
        iconHeadBorderPercent: DEFAULT_ICON_HEAD_BORDER_PERCENT,
        ...(data?.mpConfig || {}),
    },
})

export {
    CommunityDescription,
    cleanBeforeSending,
    formatCommunityData,
    DEFAULT_ICON_STYLE,
    DEFAULT_ICON_HEAD_STYLE,
    DEFAULT_ICON_HFIVE_STYLE,
    DEFAULT_TEXT_GRADIENT,
    DEFAULT_BG_HFIVE,
    DEFAULT_ICON_HEAD_BORDER_PERCENT,
}
